import primaryButton from '../../../../primary-button';

const secondary = (params) => primaryButton.solidIcon.background.active.secondary(params);

export default secondary;
